import React, { useState } from 'react';
import './DiscoverHeader.css';

const DiscoverHeader = ({ 
  soundsCount, 
  onSortChange, 
  onFilterChange, 
  selectedSort = 'popular',
  selectedFilters = []
}) => {
  const [activeSort, setActiveSort] = useState(selectedSort);

  const sortOptions = [
    { id: 'popular', label: 'Populaires', icon: '🔥' },
    { id: 'recent', label: 'Récents', icon: '⭐' },
    { id: 'duration-asc', label: 'Courts', icon: '⚡' },
    { id: 'duration-desc', label: 'Longs', icon: '🎵' }
  ];

  const quickFilters = [
    { id: 'nature', label: 'Nature', emoji: '🌿' },
    { id: 'urban', label: 'Urbain', emoji: '🏙️' },
    { id: 'music', label: 'Musical', emoji: '🎶' },
    { id: 'voice', label: 'Voix', emoji: '🗣️' },
    { id: 'short', label: '< 10s', emoji: '⚡' },
    { id: 'medium', label: '10-60s', emoji: '⏱️' }
  ];

  const handleSortClick = (sortId) => {
    setActiveSort(sortId);
    onSortChange?.(sortId);
  };

  const handleFilterToggle = (filterId) => {
    const newFilters = selectedFilters.includes(filterId)
      ? selectedFilters.filter(f => f !== filterId)
      : [...selectedFilters, filterId];
    onFilterChange?.(newFilters);
  };

  return (
    <div className="discover-header">
      <div className="discover-hero">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-icon">🎧</span>
            <span>Bibliothèque audio libre</span>
          </div>
          <h1 className="hero-title">
            Découvrez des sons 
            <span className="gradient-text"> extraordinaires</span>
          </h1>
          <p className="hero-subtitle">
            Une vaste collection de sons haute qualité, libres de droits et prêts à utiliser dans vos projets créatifs.
          </p>
        </div>
        <div className="hero-visual">
          <div className="sound-waves">
            <div className="wave wave-1"></div>
            <div className="wave wave-2"></div>
            <div className="wave wave-3"></div>
            <div className="wave wave-4"></div>
          </div>
        </div>
      </div>

      <div className="discover-controls">
        <div className="sort-section">
          <label className="control-label">Trier par :</label>
          <div className="sort-options">
            {sortOptions.map(option => (
              <button
                key={option.id}
                className={`sort-btn ${activeSort === option.id ? 'active' : ''}`}
                onClick={() => handleSortClick(option.id)}
              >
                <span className="sort-icon">{option.icon}</span>
                <span className="sort-label">{option.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="filter-section">
          <label className="control-label">Filtres rapides :</label>
          <div className="quick-filters">
            {quickFilters.map(filter => (
              <button
                key={filter.id}
                className={`filter-chip ${selectedFilters.includes(filter.id) ? 'active' : ''}`}
                onClick={() => handleFilterToggle(filter.id)}
              >
                <span className="filter-emoji">{filter.emoji}</span>
                {filter.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscoverHeader;
